import { render, staticRenderFns } from "./tahsilat.vue?vue&type=template&id=ce8303c2"
import script from "./tahsilat.vue?vue&type=script&lang=js"
export * from "./tahsilat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports